/*  ========================================================================
    # Scripts - Menu Desktop
    ========================================================================  */

/**
 * Script that handles the opening and closing of the submenus.
 */
const MenuDesktop = {
  cfg: {
    entriesWithSubmenu: document.querySelectorAll('.c-menu-desktop__entry--with-submenu'),
    classes: {
      link: 'c-menu-desktop__link',
      linkActive: 'c-menu-desktop__link--active',
      submenu: 'c-menu-desktop__submenu',
      submenuVisible: 'c-menu-desktop__submenu--visible'
    }
  },

  /**
   * Handler.
   *
   * @param {Object} accordion
   */
  handler(entryObject) {
    entryObject.link.addEventListener('click', () => {
      if (
        entryObject.link.classList.contains(this.cfg.classes.linkActive) &&
        entryObject.submenu.classList.contains(this.cfg.classes.submenuVisible)
      ) {
        entryObject.link.classList.remove(this.cfg.classes.linkActive);
        entryObject.submenu.classList.remove(this.cfg.classes.submenuVisible);
      } else {
        this.cfg.entriesWithSubmenu.forEach(entry => {
          entry
            .querySelector(`.${this.cfg.classes.link}`)
            .classList.remove(this.cfg.classes.linkActive);
          entry
            .querySelector(`.${this.cfg.classes.submenu}`)
            .classList.remove(this.cfg.classes.submenuVisible);
        });

        entryObject.link.classList.add(this.cfg.classes.linkActive);
        entryObject.submenu.classList.add(this.cfg.classes.submenuVisible);
      }
    });
  },

  /**
   * Creates an object for each entry with a submenu.
   */
  entries() {
    this.cfg.entriesWithSubmenu.forEach(entry => {
      const entryObject = {
        entry,
        link: entry.querySelector(`.${this.cfg.classes.link}`),
        submenu: entry.querySelector(`.${this.cfg.classes.submenu}`)
      };

      this.handler(entryObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.entriesWithSubmenu !== undefined && this.cfg.entriesWithSubmenu !== null) {
      this.entries();
    }
  }
};

export default MenuDesktop;
